import { WidgetScene } from "../types/widget-scenes";

declare global {
  interface Window {
    OutsellaWidget?: {
      open: (options: { agentId: string; position?: string }) => void;
    };
  }
}

function getOrCreateWidget(
  agentId: string,
  position: string = "right"
): HTMLElement {
  let widget = document.querySelector("outsella-widget") as HTMLElement;

  if (!widget) {
    widget = document.createElement("outsella-widget");
    widget.setAttribute("agentid", agentId);
    widget.setAttribute("position", position);
    document.body.appendChild(widget);
  }

  return widget;
}

function openWidget(options: { agentId: string; position?: string }) {
  const widget = getOrCreateWidget(options.agentId, options.position);

  const checkShadowRoot = setInterval(() => {
    if (widget.shadowRoot) {
      clearInterval(checkShadowRoot);

      const event = new CustomEvent("outsella-widget-open", {
        detail: { scene: WidgetScene.CHOICE },
        bubbles: true,
        composed: true,
      });
      widget.shadowRoot.dispatchEvent(event);
    }
  }, 100);
}

window.OutsellaWidget = {
  open: openWidget,
};

document.addEventListener("click", (e) => {
  const target = e.target as HTMLElement;
  const agentId = target.getAttribute("data-outsella-agentid");

  if (agentId) {
    const position = target.getAttribute("data-outsella-position") || "right";
    openWidget({ agentId, position });
  }
});

window.addEventListener("hashchange", () => {
  const hash = window.location.hash;
  if (hash.startsWith("#outsella-open=")) {
    const params = new URLSearchParams(hash.substring(1));
    const agentId = params.get("outsella-open");
    const position = params.get("outsella-position") || "right";

    if (agentId) {
      openWidget({ agentId, position });
    }
  }
});
